import { css } from 'styled-components';

export const baseStyle = css`
  margin: 0 auto;
  width: 100%;
`;
